/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {validateSession} from '../api'

export const useMutationValidateSession = createReactQueryMutationHook('validateSession', validateSession)
